export type ExtractMessageValues<Message> =
  Message extends `${infer Prefix}{- ${infer Value} }${infer Postfix}`
    ? [...ExtractMessageValues<Prefix>, Value, ...ExtractMessageValues<Postfix>]
    : Message extends `${infer Prefix}{-${infer Value}}${infer Postfix}`
    ? [...ExtractMessageValues<Prefix>, Value, ...ExtractMessageValues<Postfix>]
    : Message extends `${infer Prefix}{${infer Value}}${infer Postfix}`
    ? [...ExtractMessageValues<Prefix>, Value, ...ExtractMessageValues<Postfix>]
    : [];

export type ParsedMessage<Message extends string> = {
  rawMessage: Message;
};

export function parse<Message extends string = string>(
  rawMessage: Message,
): ParsedMessage<Message> {
  return {
    rawMessage,
  };
}
